// extracted by mini-css-extract-plugin
export default {"login-page":"styles_login-page__p-yPT"};